// Create mixins
import Vue from 'vue';

Vue.mixin({
  methods: {
    log(msg) {
      window.console.log(msg);
    },
    error(msg) {
      window.console.error(msg);
    },
    debug(msg) {
      window.console.debug(msg);
    },
    warn(msg) {
      window.console.warn(msg);
    },
  },
});
